import React, { useContext } from 'react';
import {
  number, string, func, bool, object, arrayOf
} from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { CheckAvailability } from '@thd-olt-component-react/check-availability';
import { dataModel } from './dataModel';
import './fulfillment.scss';
import { isShowBoth, isTwoTile, isTwoTileOff } from './helper/utils';
import { FulfillmentTiles } from './tiles/FulfillmentTiles';
import { MajorApplianceThreeTiles } from './threeTiles/MajorApplianceThreeTiles';

const MajorApplianceFulfillment = (props) => {
  const {
    itemId,
    storeId,
    configurableApplianceItemIds,
    quantity,
    onChange,
    covidAlert,
    bopisMinimumThreshold,
    bopisMinimumThresholdStores,
    bopisHolidayTiming,
    isTwoTileEnabledFS,
    twoTileView,
    directData,
    applianceDirectData
  } = props;

  if (isTwoTileEnabledFS || ((twoTileView || isTwoTile() || isShowBoth()) && !isTwoTileOff())) {
    return (
      <>
        <FulfillmentTiles
          itemId={itemId}
          storeId={storeId}
          configurableApplianceItemIds={configurableApplianceItemIds}
          covidAlert={covidAlert}
          quantity={quantity}
          onChange={onChange}
          thresholds={{
            bopisMinimumThreshold,
            bopisMinimumThresholdStores,
            bopisHolidayTiming
          }}
          directData={directData}
          applianceDirectData={applianceDirectData}
        />
        {isShowBoth() && (
          <MajorApplianceThreeTiles
            itemId={itemId}
            storeId={storeId}
            configurableApplianceItemIds={configurableApplianceItemIds}
            covidAlert={covidAlert}
            quantity={quantity}
            onChange={onChange}
            bopisMinimumThreshold={bopisMinimumThreshold}
            bopisMinimumThresholdStores={bopisMinimumThresholdStores}
            bopisHolidayTiming={bopisHolidayTiming}
            directData={directData}
          />
        )}
      </>
    );
  }

  // else fallback to original
  return (
    <MajorApplianceThreeTiles
      itemId={itemId}
      storeId={storeId}
      configurableApplianceItemIds={configurableApplianceItemIds}
      covidAlert={covidAlert}
      quantity={quantity}
      onChange={onChange}
      bopisMinimumThreshold={bopisMinimumThreshold}
      bopisMinimumThresholdStores={bopisMinimumThresholdStores}
      bopisHolidayTiming={bopisHolidayTiming}
      directData={directData}
    />
  );
};

MajorApplianceFulfillment.displayName = 'MajorApplianceFulfillment';

MajorApplianceFulfillment.propTypes = {
  /** An Item that has product highlights */
  itemId: string.isRequired,
  configurableApplianceItemIds: arrayOf(string),
  covidAlert: bool,
  storeId: string,
  quantity: number,
  onChange: func,
  bopisMinimumThreshold: number,
  bopisMinimumThresholdStores: string,
  bopisHolidayTiming: number,
  twoTileView: bool,
  // eslint-disable-next-line react/forbid-prop-types
  directData: object,
  // eslint-disable-next-line react/forbid-prop-types
  applianceDirectData: object,
  isTwoTileEnabledFS: bool
};

MajorApplianceFulfillment.defaultProps = {
  configurableApplianceItemIds: null,
  covidAlert: false,
  quantity: 1,
  storeId: null,
  bopisMinimumThreshold: null,
  bopisMinimumThresholdStores: null,
  onChange: () => {},
  bopisHolidayTiming: null,
  twoTileView: false,
  directData: null,
  applianceDirectData: null,
  isTwoTileEnabledFS: false,
};

// ['identifiers', 'info', 'pricing', 'availabilityType', 'fulfillment']
MajorApplianceFulfillment.dataModel = extend(
  CheckAvailability,
  dataModel
);

export { MajorApplianceFulfillment };
